export const FinancialInvestmentType = {
  CANDIDATURE: 'CANDIDATURE',
  ANALYSIS: 'ANALYSIS',

  values: () => {
    return ['CANDIDATURE', 'ANALYSIS'];
  }
};
